import { s } from "./i18n"

export const THREAD_COLORS = [
  { label: s`Orange`, value: "#ee450f" },
  { label: s`Salmon`, value: "#fe4949" },
  { label: s`Peach`, value: "#FF7F5C" },
  { label: s`Yellow`, value: "#F9C74F" },
  { label: s`Coffee`, value: "#652727" },
  { label: s`Brown`, value: "#845633" },
  { label: s`Blue`, value: "#1B4582" },
  { label: s`Navy`, value: "#143244" },
  { label: s`Indigo`, value: "#533AA6" },
  { label: s`Purple`, value: "#8C2DBF" },
  { label: s`Teal`, value: "#007E7C" },
  { label: s`Green`, value: "#98A65D" },
  { label: s`Cornflower`, value: "#5CA9E6" },
  { label: s`Grey`, value: "#A9B0B9" },
]
export default THREAD_COLORS
